<template>
  <md-dialog
    class="appeals-category-modal"
    :md-active.sync="showDialog"
    style="overflow: visible"
    @md-clicked-outside="closeDialog"
  >
    <md-toolbar
      md-elevation="0"
      class="md-transparent md-blue"
      :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
    >
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">
            <template v-if="selected.length > 0">
              <a class="cat-back-link" href="#" @click="back">
                <md-icon>arrow_back_ios</md-icon>
                Категории заявки
              </a>
            </template>
            <template v-else>
              <a class="cat-back-link" href="#" @click="closeDialog">
                <md-icon>arrow_back_ios</md-icon>
                Выберите категорию
              </a>
            </template>
          </h3>
        </div>
        <div class="md-toolbar-section-end">
        </div>
      </div>
    </md-toolbar>

    <div class="custom-content">
      <div class="table-title md-theme-block-head-color">
        ТИПОВЫЕ ЗАЯВКИ
      </div>
      <table class="custom-dense-table text-main-black">
        <tbody>
        <tr v-for="(cat, i) in list" :key="cat.id" @click="clickHandle(cat)">
          <td>{{ cat.name }}</td>
          <td class="text-align-right">
            <md-icon class="text-main-blue">chevron_right</md-icon>
          </td>
        </tr>
        </tbody>
      </table>

      <template v-if="selected.length === 0">
        <div class="table-title md-theme-block-head-color">
          СВОБОДНАЯ ФОРМА
        </div>
        <table class="custom-dense-table text-main-black">
          <tbody>
          <tr @click="freeForm">
            <td>Создать</td>
            <td class="text-align-right">
              <md-icon class="text-main-blue">chevron_right</md-icon>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
    </div>
  </md-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AppealsCategoryModal",
  data() {
    return {
      parentName: null,
      selected: []
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters([
      'categories'
    ]),

    list() {
      return this.selected.length > 0 ? this.selected : this.categories;
    }
  },
  methods: {
    back() {
      this.selected = [];
    },
    clickHandle(cat) {
      const isParent = cat.children.length > 0;
      if (isParent) {
        this.parentName = cat.name;
        this.selected = [ ...cat.children ]
      } else {
        this.$emit('onSelect', { ...cat, fullName: `${this.parentName}/${cat.name}`})
        this.closeDialog()
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
      this.selected = [];
    },
    freeForm() {
      this.$emit("onFreeFormSelected");
      this.closeDialog();
    }
  }
}
</script>

<style lang="scss" scoped>
.appeals-category-modal {
  .table-title {
    @media (max-width: 768px) {
      padding: 0 20px 10px 20px;
    }
  }
  .custom-dense-table {
    margin-bottom: 20px;
    tbody td {
      padding: 10px 10px;
    }
    tbody tr {
      @media (max-width: 768px) {
        background-color: #ffffff;
      }
    }
  }
  .custom-content {
    min-height: 131px;
    padding: 20px 24px 20px 24px;
    @media (max-width: 768px) {
      height: 100%;
      padding: 20px 0 0 0;
      background-color: #eee;
    }
  }

  .cat-back-link {
    color: #ffffff !important;
    display: flex;
    align-items: center;
    .md-icon {
      color: #ffffff !important;
    }
  }
}
</style>
